import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { Storage } from 'aws-amplify';
import { fetchKansatsuKiroku, getKansatsuKiroku, postKansatsuKiroku, uploadImage, getArchiveStatus } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';
import { KansatsuKiroku } from '../../../models/KansatsuKiroku';

const fetch = ({ koujiBangou }
      : { koujiBangou: string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    const result = await fetchKansatsuKiroku({ koujiBangou });

    // ArchiveStatusを取得するAPIをループで呼び出す
    const archiveStatus = async (record: KansatsuKiroku): Promise<null> => {
      const archiveStatusResult = await getArchiveStatus({ koujiBangou: record.koujiBangou, key: record.key });
      // 検索結果を観察記録のレコードに設定する
      record.downloadFileStatus = archiveStatusResult.status;
      record.downloadFileBucket = archiveStatusResult.bucket;
      record.downloadFileKey = archiveStatusResult.fileKey;
      record.downloadFileCreationDatetime = archiveStatusResult.createdAt;
      return null;
    };
    await Promise.all(result.Items.map(r => archiveStatus(r)));
    dispatch(actions.fetchRecords.done({ params: { koujiBangou }, result }));
  } catch (error) {
    dispatch(actions.fetchRecords.failed({ params: { koujiBangou }, error: error.toString() }));
    getLogger().error('kansatsuKiroku/fetch()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const get = ({ koujiBangou, key }
      : { koujiBangou: string; key:string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    const result = await getKansatsuKiroku({ koujiBangou, key });
    // 画像の情報があればSignedURLを生成して返す
    if (result.croppedImageBucket && result.croppedImageKey) {
      result.croppedImageSignedUrl =
        await Storage.get(
          result.croppedImageKey,
          {
            customPrefix: {
              public: ''
            }
          }) as string
    }
    dispatch(actions.getRecord.done({ params: { koujiBangou, key }, result: { Item: result }}));
  } catch (error) {
    dispatch(actions.getRecord.failed({ params: { koujiBangou, key }, error: error.toString() }));
    getLogger().error('kansatsuKiroku/get()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}
const post = (
      record : KansatsuKiroku,
      originalImageStr: string | undefined = undefined,
      originalImageContentType: string | undefined = undefined
    ) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    // オリジナル画像が指定されているときはアップロードする
    if (originalImageStr && originalImageContentType) {
      // 拡張子をcontentTypeから取得する
      const ext = originalImageContentType.toLowerCase().endsWith('png')
              ? 'png'
              : 'jpeg'
      // ファイル名生成
      const key = `${record.inferenceId}.${ext}`;
      console.time('upload original image');
      await uploadImage({ key, imageStr: originalImageStr, contentType: originalImageContentType });
      console.timeEnd('upload original image');
      record.originalImageBucket = process.env.REACT_APP_IMAGEUPLOADBUCKETNAME || '';
      record.originalImageKey = key;
    }
    await postKansatsuKiroku({ item: record });
    dispatch(actions.postRecord.done({ params: { item: record }, result: { item: record }}));
    // 削除日時が指定されているかどうかで結果メッセージを変更
    const message = record.deletedAt ? '削除しました。' : '保存しました。';
    systemStateMessageOperations.putSuccess({ message })(dispatch);
  } catch (error) {
    dispatch(actions.postRecord.failed({ params: { item: record }, error: error.toString() }));
    getLogger().error('kansatsuKiroku/post()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const resetRecord = () => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.resetRecord());
};


export {
  fetch,
  get,
  post,
  resetRecord
};



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKiroku/operations.ts